import { BusinessObjectBase } from './base';
import type { Candidate } from './candidate';

export interface LanguageAndSkillsData {
  readonly id: number;
  readonly azerbaijaniLevel?: string;
  readonly englishLevel?: string;
  readonly arabicLevel?: string;
  readonly firstAidCertificate?: string;
  readonly behavioralResponse?: string;
  readonly candidateId: number;
  readonly candidate?: Candidate;
}

export interface LanguageAndSkills extends Readonly<LanguageAndSkillsData> {}
export class LanguageAndSkills extends BusinessObjectBase {
  static readonly entityName = 'LanguageAndSkills' as const;
  static readonly plural = 'language-and-skills';

  // --- Static CRUD methods ---

  static async find(filter?: any): Promise<LanguageAndSkills[]> {
    const url = `${this.baseUrl}/${this.plural}`;
    const params: Record<string, string> = {};
    if (filter) params['filter'] = JSON.stringify(filter);
    const results = await this.get<any[]>(url, params);
    return results.map((data) => new LanguageAndSkills(data));
  }

  static async findOne(filter?: any): Promise<LanguageAndSkills | null> {
    const url = `${this.baseUrl}/${this.plural}/find-one`;
    const params: Record<string, string> = {};
    if (filter) params['filter'] = JSON.stringify(filter);
    const data = await this.get<any>(url, params);
    return data ? new LanguageAndSkills(data) : null;
  }

  static async findById(id: number, filter?: any): Promise<LanguageAndSkills> {
    const url = `${this.baseUrl}/${this.plural}/${id}`;
    const params: Record<string, string> = {};
    if (filter) params['filter'] = JSON.stringify(filter);
    const data = await this.get<any>(url, params);
    return new LanguageAndSkills(data);
  }

  static async create(
    data: Omit<LanguageAndSkillsData, 'id'>,
  ): Promise<LanguageAndSkills> {
    const url = `${this.baseUrl}/${this.plural}`;
    const result = await this.post<any>(url, data);
    return new LanguageAndSkills(result);
  }

  static async updateById(
    id: number,
    data: Partial<LanguageAndSkillsData>,
  ): Promise<LanguageAndSkills> {
    const url = `${this.baseUrl}/${this.plural}/${id}`;
    const result = await this.patch<any>(url, data);
    return new LanguageAndSkills(result);
  }

  static async deleteById(id: number): Promise<boolean> {
    const url = `${this.baseUrl}/${this.plural}/${id}`;
    try {
      await this.del<void>(url);
      return true;
    } catch {
      return false;
    }
  }
}
